import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import starFill from "../../../asset/img/star_fill.png";
import { getFavsport, setFavsport } from "../../actions/gameSettings";
import MatchStatus from "../../lib/DateLive";
import DataFetchStatus from "../../common/DataFetchStatus";
import { toastAlert } from "../../lib/toastAlert";
import { ImageComponent } from "../../global/imageComponent";
import TeamLogo from "../../common/TeamLogo";
import "./favorites.css";
import { getMatchOddsDisplay } from "../../../utility/matchOdds";
import MatchOddsPills from "../../common/MatchOddsPills";
import SportIcon from "../../common/SportIcon";
import {
  fetchSportGroupIconMaps,
  resolveSportIconUrl,
} from "../../../services/sportGroupIcons";

const Favoritescont = () => {
  const history = useHistory();
  const [Teams, setTeams] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fetchError, setFetchError] = useState(null);
  const [sportIconMaps, setSportIconMaps] = useState({ groups: {}, titles: {} });

  const handleCardClick = (item) => {
    if (!item) return;
    const sport = item.sport_title || "A-Z Betting";
    history.push(`/straight-bet/${sport}`, {
      selectedSport: sport,
      selectedTeam: item,
    });
  };

  const favSportFetch = async () => {
    setLoading(true);
    setFetchError(null);
    try {
      const fetchedData = await getFavsport();
      if (fetchedData?.status === false && fetchedData?.message) {
        setFetchError(fetchedData.message);
      }
      if (fetchedData?.result?.length > 0) {
        setTeams(fetchedData.result);
      } else {
        setTeams([]);
      }
    } catch (e) {
      setFetchError("Unable to load favorites. Please try again.");
      setTeams([]);
    } finally {
      setLoading(false);
    }
  };

  const handleLikeButton = async (item) => {
    if (!item?.id) return;

    const prevTeams = Teams;
    setTeams((prev) => prev.filter((team) => team.id !== item.id));
    toastAlert("success", "Removed from Favorites", "favorite-toggle");

    try {
      const response = await setFavsport(item);
      if (!response?.status) {
        setTeams(prevTeams);
        toastAlert(
          "error",
          response?.message || "Unable to update favorite. Please try again.",
          "favorite-toggle"
        );
      }
    } catch (err) {
      console.log("handleLikeButton error", err);
      setTeams(prevTeams);
      toastAlert(
        "error",
        "Unable to update favorite. Please try again.",
        "favorite-toggle"
      );
    }
  };

  useEffect(() => {
    favSportFetch();
    fetchSportGroupIconMaps().then(setSportIconMaps);
  }, []);

  return (
    <section>
      <div className="dashboard_content_sec">
        <div className="favorites mt-5 px-3">
          <h5 className="mb-0 fav-page-title">Favorites Matches</h5>

          <DataFetchStatus loading={loading} error={fetchError}>
            {Teams.length > 0 ? (
              <div className="row mt-4 g-3">
                {Teams.map((item) => {
                  const {
                    homeLabel,
                    awayLabel,
                    homeDisplay,
                    awayDisplay,
                    hasOdds,
                  } = getMatchOddsDisplay(item);

                  const onCardKeyDown = (e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      handleCardClick(item);
                    }
                  };

                  return (
                    <div
                      key={item.id}
                      className="col-sm-6 col-lg-4 col-xl-3 d-flex"
                    >
                      <article
                        className="fav-card"
                        role="button"
                        tabIndex={0}
                        onClick={() => handleCardClick(item)}
                        onKeyDown={onCardKeyDown}
                        aria-label={`View match: ${item.home_team} vs ${item.away_team}`}
                      >
                        <header className="fav-card__header">
                          <span className="fav-card__sport">
                            <SportIcon
                              sportName={item.sport_title}
                              iconUrl={resolveSportIconUrl(item.sport_title, sportIconMaps)}
                              className="fav-card__sport-icon"
                              alt=""
                              size={20}
                            />
                            {item.sport_title}
                          </span>
                          <button
                            type="button"
                            className="fav-card__star-btn"
                            aria-label="Remove from favorites"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleLikeButton(item);
                            }}
                          >
                            <img src={starFill} alt="" />
                          </button>
                        </header>

                        <div className="fav-card__matchup">
                          <div className="fav-card__side">
                            <TeamLogo
                              teamName={item.home_team}
                              logoUrl={item.home_team_logo}
                              className="fav-card__team-icon"
                              size="md"
                              alt={item.home_team}
                            />
                            <p className="fav-card__team-name">{item.home_team}</p>
                          </div>

                          <ImageComponent
                            staticImgSrc="vsIcon"
                            className="fav-card__vs-icon"
                            alt=""
                          />

                          <div className="fav-card__side fav-card__side--away">
                            <TeamLogo
                              teamName={item.away_team}
                              logoUrl={item.away_team_logo}
                              className="fav-card__team-icon"
                              size="md"
                              alt={item.away_team}
                            />
                            <p className="fav-card__team-name">{item.away_team}</p>
                          </div>
                        </div>

                        <footer className="fav-card__footer">
                          <MatchStatus matchTime={`${item?.commence_time}`} />
                          {hasOdds && (
                            <MatchOddsPills
                              homeLabel={homeLabel}
                              awayLabel={awayLabel}
                              homeDisplay={homeDisplay}
                              awayDisplay={awayDisplay}
                              className="fav-card__odds"
                            />
                          )}
                        </footer>
                      </article>
                    </div>
                  );
                })}
              </div>
            ) : (
              !loading &&
              !fetchError && (
                <p className="text-center mt-5 fav-empty-msg">
                  No Favorite Matches
                </p>
              )
            )}
          </DataFetchStatus>
        </div>
      </div>
    </section>
  );
};

export default Favoritescont;
